module.exports = __webpack_public_path__ + "static/media/Study 01.3d6eca6f.png";